// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-group[data-v-09cef40c] legend.v-label{width:100%;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
